import ArchieveResult from './archive-result';

export default ArchieveResult;
